import React from 'react';

function insertPlainText(target: HTMLElement, value: string): void {
  if (!value) return;
  const selection = window.getSelection();
  if (!selection || selection.rangeCount === 0) return;
  const range = selection.getRangeAt(0);
  if (!target.contains(range.commonAncestorContainer)) return;

  range.deleteContents();
  const text = document.createTextNode(normalizeEditableText(value));
  range.insertNode(text);
  range.setStartAfter(text);
  range.collapse(true);
  selection.removeAllRanges();
  selection.addRange(range);
}

/** Insert plain text without browser-generated rich-text elements. */
export function handlePlainTextInput(event: React.FormEvent<HTMLElement>): void {
  const inputType = (event.nativeEvent as InputEvent).inputType;
  if (inputType !== 'insertParagraph' && inputType !== 'insertLineBreak') return;
  event.preventDefault();
  insertPlainText(event.currentTarget, '\n');
}

/** Insert a plain newline in a contentEditable element without browser HTML blocks. */
export function handlePlainLineBreak(event: React.KeyboardEvent<HTMLElement>): void {
  if (event.key !== 'Enter' || event.ctrlKey || event.metaKey || event.altKey) return;
  event.preventDefault();
  insertPlainText(event.currentTarget, '\n');
}

/** Strip formatting from pasted content before inserting it. */
export function handlePlainPaste(event: React.ClipboardEvent<HTMLElement>): void {
  event.preventDefault();
  insertPlainText(event.currentTarget, event.clipboardData.getData('text/plain'));
}

/** Strip formatting from dropped content before inserting it. */
export function handlePlainDrop(event: React.DragEvent<HTMLElement>): void {
  event.preventDefault();
  insertPlainText(event.currentTarget, event.dataTransfer.getData('text/plain'));
}

/** Read editable text consistently, preserving intentional line breaks. */
export function normalizeEditableText(value: string | null | undefined): string {
  return (value ?? '')
    .replace(/\r\n?/g, '\n')
    .replace(/\u00a0/g, ' ')
    .replace(/[^\S\n]+/g, ' ')
    .replace(/ *\n */g, '\n');
}
